/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/MindHarborOrderHistory/UserOrderHistory',[
    'jquery',
    'lodash',
    'moment',
    'global/all',
    'modules/QuickView/QuickView',
    './UserOrderHistory.Constants',
    './UserOrderHistory.Helper',
    './UserOrderHistoryService',
    'plugins/daterangepicker'
], function ($, _, moment, Roc, QuickView, Selectors, UserOrderHistoryHelper, UserOrderHistoryService) {
    'use strict';
    var isSalesRep = false;
    var pagination;

    function searchEvt() {
        $(document)
            .off('click', Selectors.searchBar.searchBtn)
            .on('click',
                Selectors.searchBar.searchBtn,
                function () {
                    /* 1 = pageNum */
                    searchAndRender();
                });
    }

    function customerIdChangedEvt() {
        $(document)
            .off('change', Selectors.searchBar.customerId)
            .on('change', Selectors.searchBar.customerId,
                function () {
                    Roc.UI.block(Selectors.orderHistoryWrapper);
                    var customerId = $(this).val();
                    updateShipTosDropdown(customerId);
                });
    }

    function viewOrderDetailsEvt() {
        $(document).on('click', Selectors.orderDetailsBtn, function () {
            var detailsBtn = $(this);
            if (!detailsBtn.hasClass('collapsed')) {
                Roc.Core.lockButton(detailsBtn);
                var orderNo = detailsBtn.data('id');
                var shipToId = detailsBtn.data('shiptoId');
                var orderDetailsContainer = $('#order-' + orderNo + '-details');
                Roc.UI.block(orderDetailsContainer);
                UserOrderHistoryService.getOrderDetails(orderNo)
                    .then(function (response) {
                        response.shipToId = shipToId;
                        response.isSalesRep = isSalesRep;
                        Roc.UI.template('userOrderDetails-Tmp', response)
                            .then(function (rendererdTemplate) {
                                orderDetailsContainer.html(rendererdTemplate);
                            });
                    })
                    .fail(function () {
                        Roc.UI.displayErrorPopup("An error occurred while attempting to get order details");
                    })
                    .always(function () {
                        Roc.Core.releaseLockedButton(detailsBtn);
                        Roc.UI.unblock(orderDetailsContainer);
                        UserOrderHistoryHelper.toggleDetailsBtnText(detailsBtn);
                    });
            } else {
                UserOrderHistoryHelper.toggleDetailsBtnText(detailsBtn);
            }
        });
    }


    function viewItemHistoryEvt() {
        $(document).on('click', Selectors.itemHistoryBtn, function () {
            var itemHistoryBtn = $(this);
            Roc.Core.lockButton(itemHistoryBtn);
            var invMastUid = itemHistoryBtn.data('invmastuid');
            var shipToId = itemHistoryBtn.data('shiptoId');
            UserOrderHistoryService.getItemHistory(invMastUid, shipToId)
                .then(function (response) {
                    Roc.UI.template('#itemHistory-Tmp', response).then(function (renderedTemplate) {
                        Roc.UI.Modal.open(renderedTemplate);
                    });
                })
                .fail(function () {
                    Roc.UI.displayErrorPopup("An error occurred while attempting to get item History");
                })
                .always(function () {
                    Roc.Core.releaseLockedButton(itemHistoryBtn);
                });
        });
    }

    function viewItemHistoryDetailEvt() {
        $(document).on('click', Selectors.itemHistoryDetailBtn, function () {
            var itemHistoryDetailBtn = $(this);
            Roc.Core.lockButton(itemHistoryDetailBtn);
            var invMastUid = itemHistoryDetailBtn.data('invmastuid');
            var shipToId = itemHistoryDetailBtn.data('shiptoId');
            UserOrderHistoryService.getItemHistoryDetail(invMastUid, shipToId)
                .then(function (response) {
                    Roc.UI.template('#itemHistoryDetail-Tmp', response).then(function (renderedTemplate) {
                        Roc.UI.Modal.open(renderedTemplate);
                    });
                })
                .fail(function () {
                    Roc.UI.displayErrorPopup("An error occurred while attempting to get item history detail");
                })
                .always(function () {
                    Roc.Core.releaseLockedButton(itemHistoryDetailBtn);
                });
        });
    }

    function openQuickViewEvt() {
        $(document).on('click', Selectors.itemQuickView, function (e) {
            e.preventDefault();
            var id = $(this).data('productId');
            QuickView.getProduct(id);
        });
    }

    /* Methods */
    function updateShipTosDropdown(customerId) {
        UserOrderHistoryService.getCustomerShipTos(customerId)
            .then(function (response) {
                Roc.UI.template('shipTosDropDown-Tmp', response)
                    .then(function (rendererdTemplate) {
                        $(Selectors.searchBar.shipTo).html(rendererdTemplate);
                    });
            })
            .fail(function () {
                Roc.UI.displayErrorPopup("An error occurred while attempting to Customer shiptos");
            }).always(function () {
                Roc.UI.unblock(Selectors.orderHistoryWrapper);
            });
    }

    function searchAndRender(pg) {
        pg = pg || pagination;
        Roc.Core.lockButton(Selectors.searchBar.searchBtn);
        Roc.UI.block(Selectors.ordersWrapper);

        var searchOrdersRequest = UserOrderHistoryHelper.createSearchRequest(pg.page);
        if (!searchOrdersRequest.startDate || !searchOrdersRequest.endDate) {
            Roc.UI.displayErrorPopup("Please select a valid date range.");
            Roc.Core.releaseLockedButton(Selectors.searchBar.searchBtn);
            Roc.UI.unblock(Selectors.ordersWrapper);
            return;
        }

        UserOrderHistoryService.getOrders(searchOrdersRequest)
            .then(function (response) {
                if (response.isSuccess) {
                    response.orderHistory.shopForOrganizationId = response.shopForOrganizationId;
                    response.orderHistory.shopForOrganizationName = response.shopForOrganizationName;
                    loadResults(response.orderHistory);
                } else {
                    if (response.errorMessage) {
                        Roc.UI.displayErrorPopup(response.errorMessage);
                    } else {
                        Roc.UI.displayErrorPopup("An error occurred while attempting to get user order history");
                    }
                }
            })
            .fail(function () {
                Roc.UI.displayErrorPopup("An error occurred while attempting to get user order history");
            })
            .always(function () {
                Roc.Core.releaseLockedButton(Selectors.searchBar.searchBtn);
                Roc.UI.unblock(Selectors.ordersWrapper);
                $(Selectors.searchBar.searchPanel).focus();
            });
    }

        function loadResults(response) {
        Roc.UI.template('userOrderHistory-Tmp', response)
            .then(function (renderedTemplate) {
                $(Selectors.ordersWrapper).html(renderedTemplate);
            });
        pagination = Roc.Pagination.updatePaging(response);
    }

    function pressEnterOnSearchPanelEvt() {
        $(document)
            .off('keydown', Selectors.searchBar.searchPanel)
            .on('keydown', Selectors.searchBar.searchPanel,
                function (event) {
                    // Number 13 is the "Enter" key on the keyboard
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        // Trigger the button element with a click
                        $(Selectors.searchBar.searchBtn).trigger("click");
                    }
                });
    }

    /* bind events */
    function bindEvents() {
        searchEvt();
        viewOrderDetailsEvt();
        customerIdChangedEvt();
        openQuickViewEvt();
        pressEnterOnSearchPanelEvt();
        viewItemHistoryEvt();
        viewItemHistoryDetailEvt();
    };

    function init(model) {
        isSalesRep = model.isSalesRep;
        initDateRangePicker(model.allowedOrderHistoryPeriodInYears);

        pagination = Roc.Pagination.init({
            page: 1,
            pageSize: model.defaultPageSize,
            totalPages: 0
        }, searchAndRender);
        /* 1 = pageNum */
        searchAndRender(pagination);
        bindEvents();
    };


    function initDateRangePicker(allowedPeriod) {
        var start = moment().startOf('month');
        var end = moment();
        var minDate = moment().subtract(allowedPeriod, 'years');

        $(Selectors.searchBar.dateRangeLabel).html("Month to Date");
        fillDateRangeInput(start, end);

        $('#daterangecontainer').daterangepicker({
            startDate: start,
            endDate: end,
            minDate: minDate,
            maxSpan: {
                'months': 6
            },
            ranges: {
                'Month to Date': [start, end],
                'Last 12 Months': [moment().subtract(12, 'months'), moment()]
            }
        }, function (start, end, label) {
            if (label && label !== "Custom Range") {
                $(Selectors.searchBar.dateRangeLabel).html(label);
            } else {
                $(Selectors.searchBar.dateRangeLabel).html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
            }
            fillDateRangeInput(start, end);
        });

    }

    function fillDateRangeInput(start, end) {
        $(Selectors.searchBar.dateRange).val(start.format('MM-DD-YYYY') + ' - ' + end.format('MM-DD-YYYY'));
    }

    var UserOrderHistory = {
        init: init
    };

    Roc.Logger.debug('UserOrderHistory.js Loaded:', UserOrderHistory);

    return UserOrderHistory;
});
